/**
 * AUTO-GENERATED file - do NOT modify by hand.
 * See EuReachVersionsExtractor.EmitVersionFileTypeScript in ListDataRefresh/EuExtractor.cs
 */

export interface ReachListVersion {
    date: string;
    count: number;
}

export class ReachListVersions {
    public static readonly reachListVersions: ReachListVersion[] = [
        { date: "2026-02-04", count: 253 },
        { date: "2025-11-05", count: 251 },
        { date: "2025-06-25", count: 250 },
        { date: "2025-01-21", count: 247 },
        { date: "2024-11-07", count: 242 },
        { date: "2024-06-27", count: 241 },
        { date: "2024-01-23", count: 240 },
        { date: "2023-06-14", count: 235 },
        { date: "2023-01-17", count: 233 },
        { date: "2022-06-10", count: 224 },
        { date: "2022-01-17", count: 223 },
        { date: "2021-07-08", count: 219 },
        { date: "2021-01-19", count: 211 },
        { date: "2020-06-25", count: 209 },
        { date: "2020-01-16", count: 205 },
        { date: "2019-07-16", count: 201 },
        { date: "2019-01-15", count: 197 },
        { date: "2018-06-27", count: 191 },
        { date: "2018-01-15", count: 181 },
        { date: "2017-07-07", count: 174 },
        { date: "2017-01-12", count: 173 },
        { date: "2016-06-20", count: 169 },
        { date: "2015-12-17", count: 168 },
        { date: "2015-06-15", count: 163 },
        { date: "2014-12-17", count: 161 },
        { date: "2014-06-16", count: 155 },
        { date: "2013-12-16", count: 151 },
        { date: "2013-06-20", count: 144 },
        { date: "2012-12-19", count: 138 },
        { date: "2012-06-18", count: 84 },
        { date: "2011-12-19", count: 71 },
        { date: "2011-06-20", count: 51 },
        { date: "2010-12-15", count: 44 },
        { date: "2010-06-18", count: 36 },
        { date: "2010-03-30", count: 28 },
        { date: "2010-01-13", count: 27 },
        { date: "2008-10-28", count: 15 },
    ];
}
